import { render, staticRenderFns } from "./imageBox.vue?vue&type=template&id=17675c24&scoped=true&"
import script from "./imageBox.vue?vue&type=script&lang=js&"
export * from "./imageBox.vue?vue&type=script&lang=js&"
import style0 from "./imageBox.vue?vue&type=style&index=0&id=17675c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17675c24",
  null
  
)

export default component.exports